<template>
  <div>
    <!-- <v-alert v-if="!isBrokerLeadForecasted" class="errorAlert" dense dismissible closable @input="onDismissLeadRequest" transition="scale-transition" type="error">
        You must have to submit the required SQL and MQL leads to access the SQL and MQL auctions.
        <a href="#" @click.prevent="goToLeadRequestTab">Click here</a> to go to the LEAD REQUEST Tab.
    </v-alert> -->
    <md-tabs class="md-secondary centered-tabs" :md-active-tab="selectedTab" @md-changed="tabChanged">
      <md-tab id="tab-calculator" md-label="Repayment Calculator"/>
      <md-tab id="payslip-calculator" md-label="Income Calculator"/>
      <!-- 
      <md-tab id="tab-auctions" md-label="SQL Auction" :md-disabled="!isBrokerLeadForecasted"/>
      <md-tab id="tab-mql-auctions" md-label="MQL Auction" :md-disabled="!isBrokerLeadForecasted"/> -->
      <md-tab id="tab-auctions" md-label="SQL Auction"/>
      <md-tab id="tab-mql-auctions" md-label="MQL Auction"/>
      <md-tab v-if="userHasRole('super-admin')" id="tab-referrers" md-label="Partner Opportunities"/>
      <md-tab
        v-if="userHasRole('super-admin') || (isSevenDaysBeforeMonthEnd && (userHasRole('Broker') || isPodManager)) || !isBrokerLeadForecasted"
        id="tab-lead-request"
        md-label="Leads Request"
      />
    </md-tabs>

    <div v-if="selectedTab === 'tab-calculator'">
      <calculators />
    </div>

    <div v-if="selectedTab === 'payslip-calculator'">
      <payslip-calculator />
    </div>

    <div v-if="selectedTab === 'tab-auctions'">
      <auction :onAuctionPage="onAuctionTab" />
    </div>
    <div v-if="selectedTab === 'tab-mql-auctions'">
      <mql-auction :onMQLAuctionPage="onMQLAuctionTab"/>
    </div>
    <div v-if="selectedTab === 'tab-referrers'">
      <Referrers />
    </div>
    <div v-if="selectedTab === 'tab-lead-request'">
      <LeadsRequest />
    </div>
  </div>
</template>

<script>
import Calculators from "@/pages/Calculators";
import PayslipCalculator from "@/pages/PayslipCalculator";
import Referrers from  "../components/Referrers";
import Auction from "@/pages/Auction";
import MqlAuction from "@/pages/MQLAuction";
import {mapGetters} from 'vuex';
import LeadsRequest from "../components/LeadsRequest.vue";

export default {
  components: {
    Calculators,
    Referrers,
    PayslipCalculator,
    Auction,
    MqlAuction,
    LeadsRequest
  },
  data() {
    return {
      error: null,
      onAuctionTab: false,
      selectedTab: null,
      onMQLAuctionTab: false,
      showDistributionTab: false,
      // Key-value reference for the tab names
      tabReference: {
        'repayment-calculator': 'tab-calculator',
        'income-calculator': 'payslip-calculator',
        'sql-auction': 'tab-auctions',
        'mql-auction': 'tab-mql-auctions',
        'partner-leads': 'tab-lead-request',
        'partner-opportunities': 'tab-referrers',
      },
    };
  },
  computed: {
    ...mapGetters([
      "user",
      "userHasRole",
      "isPodManager",
      "getLeadRequestsForecasts"
    ]),
    isBrokerLeadForecasted(){
      if(this.userHasRole('super-admin')){
        return true;
      }
      return this.getLeadRequestsForecasts;
    },
    isSevenDaysBeforeMonthEnd() {
      const today = new Date();
      const endOfMonth = new Date(today.getFullYear(), today.getMonth() + 1, 0); // Last day of the current month
      const diffDays = (endOfMonth - today) / (1000 * 60 * 60 * 24); // Difference in days
      return diffDays <= 7;
    },
  },
  watch: {
    '$route.path' (path) {
      // Remove tools from path if leaving section
      const tabs = Object.keys(this.tabReference);
      const tab = tabs.find(tab => path.includes(tab));

      if (tab == 'sql-auction' || tab == 'mql-auction') {
        this.selectedTab = this.tabReference[tab];
        this.onAuctionTab = (tab === 'sql-auction');
        this.onMQLAuctionTab = (tab === 'mql-auction');
        if (!this.isBrokerLeadForecasted && this.userHasRole('Broker')) {
          this.$router.push('/application/new/tools/partner-leads');
        }
      } else if (!tab && path !== '/application/new/tools') {
        const correctedPath = path.replace('/tools', '');
        // Push the corrected path to the router
        this.$router.push(correctedPath)
          .catch(err => {
            if (err instanceof Error && err.name !== 'NavigationDuplicated') {
              console.error(err);
            }
          });
      }
    }
  },
  async mounted() {
    const tabParam = this.$route.params.tab || 'repayment-calculator';
    this.selectedTab = this.tabReference[tabParam] || this.tabReference['repayment-calculator'];
    this.onAuctionTab = (tabParam === 'sql-auction');
    this.onMQLAuctionTab = (tabParam === 'mql-auction');

    if ((this.onAuctionTab || this.onMQLAuctionTab) && !this.isBrokerLeadForecasted && this.userHasRole('Broker')) {
      this.selectedTab = 'tab-lead-request';
      this.$router.push('/application/new/tools/partner-leads');
    } else {
      const newRoute = { name: 'Tools', params: { tab: tabParam } };
      if (this.$route.fullPath !== this.$router.resolve(newRoute).href) {
        this.$router.push(newRoute)
        .catch(err => {
            if (err instanceof Error && err.name !== 'NavigationDuplicated') {
              console.error(err);
            }
          });
        }
     }
    //  await this.$store.dispatch('fetch_lead_requests_by_user');
  },
  methods: {
    tabChanged(id) {
      const tabName = Object.keys(this.tabReference).find(name => this.tabReference[name] === id);
      if ((id === this.tabReference['sql-auction'] || id === this.tabReference['mql-auction']) && !this.isBrokerLeadForecasted && this.userHasRole('Broker')) {
        this.selectedTab = 'tab-lead-request';
        this.$router.push('/application/new/tools/partner-leads');
      } else if (tabName && this.$route.params.tab !== tabName) {
        this.selectedTab = id;
        this.onAuctionTab = (id === this.tabReference['sql-auction']);
        this.onMQLAuctionTab = (id === this.tabReference['mql-auction']);
        const newRoute = { name: 'Tools', params: { tab: tabName } };
        this.$router.push(newRoute)
          .catch(err => {
            if (err instanceof Error && err.name !== 'NavigationDuplicated') {
              console.error(err);
            }
          });
      }
    },
    goToLeadRequestTab() {
      this.selectedTab = 'tab-lead-request';
    }
  },
}
</script>

<style scoped>
.centered-tabs {
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
}
.errorAlert {
  background-color: red;
  color: white;
}

.centered-tabs .md-tabs-navigation {
  display: flex;
  justify-content: center;
  width: 100%;
  margin-bottom: 10px;
}

</style>
